import showEmployeesTemplate from './../list-employee/list-employee.html';
import showWorkDaysTemplate from './../list-work-days/list-work-days.html';
import showStudentsTemplate from './../list-student/list-student.html';
import showSchedulePointsTemplate from './../list-schedule-points/list-schedule-points.html';
import showTargetsTemplate from './../show-targets/show-targets.html';
import showActivitiesTemplate from './../list-activities/list-activities.html';
import template from './summary.html';

class SummaryComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    SchoolCommonRoomService,
    EmployeeService,
    GroupService,
    SchedulePointService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.EmployeeService = EmployeeService;
    this.GroupService = GroupService;
    this.SchedulePointService = SchedulePointService;

    this.schoolCommonRoom = {};
    this.employees = [];
    this.workDays = [];
    this.groups = [];
    this.schedulePoints = [];
  }

  $onInit() {
    this.mySchoolCommonRoom = this.SchoolCommonRoomService.getMySchoolCommonRoom();
    this.schoolYear = parseInt(this.mySchoolCommonRoom.schoolYear, 10);
    this.schoolNextYear = this.schoolYear + 1;
    this.schoolYearText = this.schoolYear + '/' + this.schoolNextYear;
  }

  showEmployees(ev) {
    this.EmployeeService.getSchoolCommonRoomEmployees()
      .then(result => {
        this.employees = result;

        this.$mdDialog.show({
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'ListEmployeeController',
          template: showEmployeesTemplate,
          locals: {employees: this.employees},
          clickOutsideToClose: true,
          targetEvent: ev
        });
      })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie można pobrać listy nauczycieli')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  showWorkDays(ev) {
    this.EmployeeService.getWorkPeriods(true).then(result => {
      this.workDays = result;

      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'ListWorkDaysController',
        template: showWorkDaysTemplate,
        locals: {workDays: this.workDays},
        clickOutsideToClose: true,
        targetEvent: ev
      });
    });
  }

  showStudents(ev) {
    this.GroupService.getAllGroups(true).then(result => {
      this.groups = result;
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'ListStudentController',
        template: showStudentsTemplate,
        locals: {groups: this.groups},
        clickOutsideToClose: true,
        targetEvent: ev
      });
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać grup świetlicowych')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  showSchedulePoints(ev) {
    this.SchedulePointService.getAll().then(result => {
      this.schedulePoints = result;

      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'ListSchedulePointsController',
        template: showSchedulePointsTemplate,
        locals: {schedulePoints: this.schedulePoints},
        clickOutsideToClose: true,
        targetEvent: ev
      });
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać planu zajęć')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  showTargets(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'ShowTargetsController',
      template: showTargetsTemplate,
      locals: {schoolCommonRoom: this.mySchoolCommonRoom},
      clickOutsideToClose: true,
      targetEvent: ev
    });
  }

  showActivities(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'ListActivitiesController',
      template: showActivitiesTemplate,
      locals: {schoolYearText: this.schoolYearText},
      clickOutsideToClose: true,
      targetEvent: ev
    });
  }

  finish(ev) {
    ev.stopPropagation();
    this.mySchoolCommonRoom.configurationCompleted = true;
    this.SchoolCommonRoomService.configuration(this.mySchoolCommonRoom).then(() => {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Pomyślnie skonfigurowano świetlicę!')
          .position('bottom right')
          .hideDelay(3000)
      );
      this.$state.go('schoolCommonRoom.select', {}, {reload: true});
    })
      .catch(({MessagePL}) => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent(MessagePL)
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }
}

export const Summary = {
  template,
  controller: SummaryComponent
};
